import React, { useState } from "react";
import { signUpUser } from "./signup";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { showSuccessToast, showErrorToast } from "../utils/toast/notificationPopup";
import AuthLayout from "../Components/AuthLayout/AuthLayout";
import "../Components/AnalyzePanel/AnalysisPanel.scss";

const SignupPage: React.FC = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSignup = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (password !== confirmPassword) {
      showErrorToast("Passwords do not match");
      return;
    }
    
    try {
      setLoading(true);
      await signUpUser(email, password, email);
      showSuccessToast("Account created. Check your email for verification code.");
      navigate(
        "/confirm-signup",
        {
          state: {
            email,
            firstName: "",
            lastName: ""
          }
        }
      );
    } catch (err: any) {
      showErrorToast(err.message || "Sign-up failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <form onSubmit={handleSignup}>
        <div className="form-group">
          <label>Email Address</label>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Password</label>
          <input
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Confirm Password</label>
          <input
            type="password"
            placeholder="Confirm your password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>
        <Button 
          className="btn btn-primary"
          variant="primary"
          style={{ cursor: "pointer" }}
          type="submit" 
          disabled={loading}
        >
          {loading ? "Creating..." : "Sign Up"}
        </Button>
      </form>
    </AuthLayout>
  );
};

export default SignupPage;
